<template>
  <div>
    <md-toolbar class="md-transparent" md-elevation="0">
      <div class="md-title">Quick Tourney</div>
      <md-icon md-src="/static/img/icons/logo.svg" class="md-size-2x"/>
    </md-toolbar>
    <md-divider></md-divider>

    <md-list>
      <md-list-item @click="setCurrentView('/publicTournaments')">
        <md-icon class="md-primary">public</md-icon>
        <span class="md-list-item-text">Public Tournaments</span>
      </md-list-item>

      <md-list-item class="section-header">
        <md-icon>favorite</md-icon>
        <span class="md-list-item-text">Recent Tournaments</span>
      </md-list-item>
      <md-list-item
        class="md-inset"
        v-for="x in favourites"
        :key="x.id"
        @click="selectTournament(x)"
      >
        <span class="md-list-item-text recent">{{x.name}}</span>
      </md-list-item>

      <div v-if="currentUser">
        <md-list-item class="section-header">
          <md-icon>person</md-icon>
          <span class="md-list-item-text">{{currentUser.user.name}}</span>
        </md-list-item>

        <md-list-item @click="showCreateTournamentDialog = true">
          <md-icon class="md-accent">add_circle</md-icon>
          <span class="md-list-item-text">Create Tournament</span>
        </md-list-item>

        <md-list-item @click="setCurrentView('/myTournaments')">
          <md-icon>domain</md-icon>
          <span class="md-list-item-text">My Tournaments</span>
        </md-list-item>

        <md-list-item @click="setCurrentView('/myLocations')">
          <md-icon>location_on</md-icon>
          <span class="md-list-item-text">My Locations</span>
        </md-list-item>
        <md-divider></md-divider>
      </div>

      <md-list-item @click="setCurrentView('/help')">
        <md-icon>help</md-icon>
        <span class="md-list-item-text">Help</span>
      </md-list-item>
      <md-list-item @click="setCurrentView('/contact')">
        <md-icon>message</md-icon>
        <span class="md-list-item-text">Contact Us</span>
      </md-list-item>
      <md-list-item @click="setCurrentView('/about')">
        <md-icon>info</md-icon>
        <span class="md-list-item-text">About</span>
      </md-list-item>
    </md-list>

    <UpsertTournamentDialog
      :show="showCreateTournamentDialog"
      @onClose="showCreateTournamentDialog = false"
    />
  </div>
</template>
<style lang="scss" scoped>
.recent {
  color: rgb(189, 102, 3);
}
.section-header {
  background-color: rgb(41, 41, 41);
}
</style>

<script>
import UpsertTournamentDialog from "@/components/dialogs/upsertTournamentDialog.vue";

export default {
  name: "MainMenu",
  components: { UpsertTournamentDialog },
  data: function() {
    return {
      showCreateTournamentDialog: false
    };
  },

  computed: {
    currentUser: {
      get() {
        return this.$store.state.currentUser;
      }
    },
    favourites: {
      get() {
        return this.$store.state.recentTournaments;
      }
    }
  },

  methods: {
    close() {
      this.$store.commit("toggleMenuVisibility");
    },
    selectTournament(item) {
      this.$store.commit("pushToRecentTournamentId", item);
      this.close();
    },
    setCurrentView(viewName) {
      this.$router.push({ path: viewName });
      this.close();
    }
  }
};
</script>



// WEBPACK FOOTER //
// MainMenu.vue?4f3c8baa